var map = {
	"./diagnosis_brostcancer/index.tsx": [
		10059,
		804,
		96,
		286
	],
	"./diagnosis_gyn/index.tsx": [
		96915,
		804,
		966
	],
	"./diagnosis_hjarntumorer/index.tsx": [
		40914,
		804,
		255
	],
	"./diagnosis_hudmelanom/index.tsx": [
		625,
		804,
		208
	],
	"./diagnosis_kll/index.tsx": [
		34478,
		804,
		43
	],
	"./diagnosis_lungcancer/index.tsx": [
		3023,
		804,
		102
	],
	"./diagnosis_myelom/index.tsx": [
		66182,
		804,
		96,
		55
	],
	"./diagnosis_njurcancer/index.tsx": [
		9090,
		804,
		419
	],
	"./diagnosis_ovarial/index.tsx": [
		19549,
		804,
		268
	],
	"./diagnosis_ppctidig/index.tsx": [
		52801,
		804,
		96,
		16
	],
	"./role_lakemedel/index.tsx": [
		98765,
		804,
		311
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 72750;
module.exports = webpackAsyncContext;